export function sortTable(item: string, filter: any) {
  if (item === filter.sort_field) {
    switch (filter.sort_mode) {
      case 'asc':
        filter.sort_mode = 'desc'
        break;
      case 'desc':
        filter.sort_mode = 'asc'
        break;
    }
  } else {
    filter.sort_field = item
    filter.sort_mode = 'asc'
  }
}